<template>
  <div id="lists">
    <el-row :gutter="20" type="flex" class="lists-row">
      <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="6" v-can="'settings.vat.view'">
        <el-card>
          <div
            slot="header"
            class="clearfix"
          >
            <span>Áfa lista</span>
            <el-button
              style="float: right; margin-top: -5px;"
              type="success"
              size="small"
              @click="$router.replace('/lists/vats/add')"
              icon="el-icon-plus"
              v-can="'settings.vat.create'"
            >
              Új Áfa
            </el-button>
          </div>
          <vat-list />
          <template v-if="$route.meta.showAddVatDialog">
            <vat-dialog type="add" />
          </template>
          <template v-if="$route.meta.showUpdateVatDialog">
            <vat-dialog
              type="update"
              :vatId="$route.params.id"
            />
          </template>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="6" v-can="'settings.country.view'">
        <el-card>
          <div
            slot="header"
            class="clearfix"
          >
            <span>Országok</span>
            <el-button
              style="float: right; margin-top: -5px;"
              type="success"
              size="small"
              @click="$router.replace('/lists/countries/add')"
              icon="el-icon-plus"
              v-can="'settings.country.create'"
            >
              Új Ország
            </el-button>
          </div>
          <country-list />
          <template v-if="$route.meta.showAddCountryDialog">
            <country-dialog type="add" />
          </template>
          <template v-if="$route.meta.showUpdateCountryDialog">
            <country-dialog
              type="update"
              :countryId="$route.params.id"
            />
          </template>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="6" v-can="'settings.county.view'">
        <el-card>
          <div
            slot="header"
            class="clearfix"
          >
            <span>Megyék</span>
            <el-button
              style="float: right; margin-top: -5px;"
              type="success"
              size="small"
              @click="$router.replace('/lists/counties/add')"
              icon="el-icon-plus"
              v-can="'settings.county.create'"
            >
              Új Megye
            </el-button>
          </div>
          <county-list />
          <template v-if="$route.meta.showAddCountyDialog">
            <county-dialog type="add" />
          </template>
          <template v-if="$route.meta.showUpdateCountyDialog">
            <county-dialog
              type="update"
              :countyId="$route.params.id"
            />
          </template>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="6" v-can="'settings.glanumber.view'">
        <el-card>
          <div
            slot="header"
            class="clearfix"
          >
            <span>Főkönyvi számok</span>
            <el-button
              style="float: right; margin-top: -5px;"
              type="success"
              size="small"
              @click="$router.replace('/lists/gla-numbers/add')"
              icon="el-icon-plus"
              v-can="'settings.glanumber.create'"
            >
              Új Főkönyvi szám
            </el-button>
          </div>
          <gla-number-list />
          <template v-if="$route.meta.showAddGlaNumberDialog">
            <gla-number-dialog type="add" />
          </template>
          <template v-if="$route.meta.showUpdateGlaNumberDialog">
            <gla-number-dialog
              type="update"
              :glaNumberId="$route.params.id"
            />
          </template>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="6" v-can="'settings.currency.view'">
        <el-card>
          <div
            slot="header"
            class="clearfix"
          >
            <span>Valuták</span>
            <el-button
              style="float: right; margin-top: -5px;"
              type="success"
              size="small"
              @click="$router.replace('/lists/currencies/add')"
              icon="el-icon-plus"
              v-can="'settings.currency.create'"
            >
              Új Valuta
            </el-button>
          </div>
          <currency-list />
          <template v-if="$route.meta.showAddCurrencyDialog">
            <currency-dialog type="add" />
          </template>
          <template v-if="$route.meta.showUpdateCurrencyDialog">
            <currency-dialog
              type="update"
              :currencyId="$route.params.id"
            />
          </template>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="6" v-can="'settings.customstariffnumber.view'">
        <el-card>
          <div
            slot="header"
            class="clearfix"
          >
            <span>Vámtarifaszámok</span>
            <el-button
              style="float: right; margin-top: -5px;"
              type="success"
              size="small"
              @click="$router.replace('/lists/customs-tariff-numbers/add')"
              icon="el-icon-plus"
              v-can="'settings.customstariffnumber.create'"
            >
              Új Vámtarifaszám
            </el-button>
          </div>
          <customs-tariff-number-list />
          <template v-if="$route.meta.showAddCustomsTariffNumberDialog">
            <customs-tariff-number-dialog type="add" />
          </template>
          <template v-if="$route.meta.showUpdateCustomsTariffNumberDialog">
            <customs-tariff-number-dialog
              type="update"
              :customsTariffNumberId="$route.params.id"
            />
          </template>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="6" v-can="'settings.packtype.view'">
        <el-card>
          <div
            slot="header"
            class="clearfix"
          >
            <span>Kiszereléstípusok</span>
            <el-button
              style="float: right; margin-top: -5px;"
              type="success"
              size="small"
              @click="$router.replace('/lists/pack-types/add')"
              icon="el-icon-plus"
              v-can="'settings.packtype.create'"
            >
              Új Kiszereléstípus
            </el-button>
          </div>
          <pack-type-list />
          <template v-if="$route.meta.showAddPackTypeDialog">
            <pack-type-dialog type="add" />
          </template>
          <template v-if="$route.meta.showUpdatePackTypeDialog">
            <pack-type-dialog
              type="update"
              :packTypeId="$route.params.id"
            />
          </template>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="6" v-can="'settings.location.view'">
        <el-card>
          <div
            slot="header"
            class="clearfix"
          >
            <span>Területek</span>
            <el-button
              style="float: right; margin-top: -5px;"
              type="success"
              size="small"
              @click="$router.replace('/lists/locations/add')"
              icon="el-icon-plus"
              v-can="'settings.location.create'"
            >
              Új Terület
            </el-button>
          </div>
          <location-list />
          <template v-if="$route.meta.showAddLocationDialog">
            <location-dialog type="add" />
          </template>
          <template v-if="$route.meta.showUpdateLocationDialog">
            <location-dialog
              type="update"
              :locationId="$route.params.id"
            />
          </template>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="6" v-can="'pricetype.view'">
        <el-card>
          <div
            slot="header"
            class="clearfix"
          >
            <span>Ár típusok</span>
            <el-button
              style="float: right; margin-top: -5px;"
              type="success"
              size="small"
              @click="$router.replace('/lists/price-types/add')"
              icon="el-icon-plus"
              v-can="'pricetype.create'"
            >
              Új ár típus
            </el-button>
          </div>
          <price-type-list />
          <template v-if="$route.meta.showAddPriceTypeDialog">
            <price-type-dialog type="add" />
          </template>
          <template v-if="$route.meta.showUpdatePriceTypeDialog">
            <price-type-dialog
              type="update"
              :priceTypeId="$route.params.id"
            />
          </template>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="6" v-can="'declutterMeasure.view'">
        <el-card>
          <div
            slot="header"
            class="clearfix"
          >
            <span>Selejtezési intézkedések</span>
            <el-button
              style="float: right; margin-top: -5px;"
              type="success"
              size="small"
              @click="$router.replace('/lists/declutter-measures/add')"
              icon="el-icon-plus"
              v-can="'declutterMeasure.create'"
            >
              Új intézkedés
            </el-button>
          </div>
          <declutter-measure-list />
          <template v-if="$route.meta.showAddDeclutterMeasureDialog">
            <declutter-measure-dialog type="add" />
          </template>
          <template v-if="$route.meta.showUpdateDeclutterMeasureDialog">
            <declutter-measure-dialog
              type="update"
              :measureId="$route.params.id"
            />
          </template>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import VatList from '../components/lists/vat/List';
  import VatDialog from '../components/lists/vat/Dialog';
  import CountryList from '../components/lists/country/List';
  import CountryDialog from '../components/lists/country/Dialog';
  import CountyList from '../components/lists/county/List';
  import CountyDialog from '../components/lists/county/Dialog';
  import GlaNumberList from '../components/lists/glaNumber/List';
  import GlaNumberDialog from '../components/lists/glaNumber/Dialog';
  import CurrencyList from '../components/lists/currency/List';
  import CurrencyDialog from '../components/lists/currency/Dialog';
  import CustomsTariffNumberList from '../components/lists/customsTariffNumber/List';
  import CustomsTariffNumberDialog from '../components/lists/customsTariffNumber/Dialog';
  import PackTypeList from '../components/lists/packType/List';
  import PackTypeDialog from '../components/lists/packType/Dialog';
  import LocationList from '../components/lists/location/List';
  import LocationDialog from '../components/lists/location/Dialog';
  import PriceTypeList from '../components/lists/priceType/List';
  import PriceTypeDialog from '../components/lists/priceType/Dialog';
  import DeclutterMeasureList from '../components/lists/declutterMeasures/List';
  import DeclutterMeasureDialog from '../components/lists/declutterMeasures/Dialog';


  export default {
    components: {
      VatList,
      VatDialog,
      CountryList,
      CountryDialog,
      CountyList,
      CountyDialog,
      GlaNumberList,
      GlaNumberDialog,
      CurrencyList,
      CurrencyDialog,
      CustomsTariffNumberList,
      CustomsTariffNumberDialog,
      PackTypeList,
      PackTypeDialog,
      LocationList,
      LocationDialog,
      PriceTypeList,
      PriceTypeDialog,
      DeclutterMeasureList,
      DeclutterMeasureDialog
    }
  }
</script>
<style scoped lang="scss">
  #lists {
    .lists-row {
      .el-col {
        margin-bottom: 20px;
      }
      flex-wrap: wrap;
    }
  }
</style>
